import { RentalObject } from './rental-object';
import { FormOfLease, RentalObjectCategory } from './const/enums';
import { Room } from './room';
import { RentalObjectKey } from './rental-object-key';
import { RentalObjectConsumptionMeter } from '../../consumption/model/rentalobject-consumption-meter';
import { ModelBase } from '../../core/model/model-base';
import { PostTargetModel } from '../service/base/post-target-loader.interface';
import { BrfSpecifics } from './brf-specifics';
import { BuildingPropertyTaxAssessment } from './building-property-tax-assesment';
import { TaxTypeCode } from './tax-type-code';
import { LinkedCustomProperty } from './linked-custom-property';

export class Premises extends RentalObject {
  constructor() {
    super();
    this.category = RentalObjectCategory.Premises;
    this.indvidualMeterElectricity = false;
    this.indvidualMeterWater = false;
    this.indvidualMeterColdWater = false;
    this.indvidualMeterHeating = false;
    this.rentalObjectCustomProperties = [];
  }

  buildingId: string;
  buildingName: string;
  entranceId: string;
  floor: number;
  indvidualMeterElectricity: boolean;
  indvidualMeterWater: boolean;
  indvidualMeterHeating: boolean;
  numberOfRooms: number;
  rooms: Room[];
  keys: RentalObjectKey[];
  indvidualMeterColdWater: boolean;
  imdMeterColdWater: RentalObjectConsumptionMeter;
  imdMeterElectricity: RentalObjectConsumptionMeter;
  imdMeterHotWater: RentalObjectConsumptionMeter;
  imdMeterHeating: RentalObjectConsumptionMeter;
  brfSpecifics: BrfSpecifics;
  condominiumShare: number;
  economicalPlanNumber: string;
  allowedFormsOfLease: FormOfLease[];
  changedAt: Date;
  propertyTax: BuildingPropertyTaxAssessment;

  propertyTaxAssessmentUnitType: Map<number, TaxTypeCode>;
  rentalObjectCustomProperties: LinkedCustomProperty[];
}

export class PremisesPostTarget extends ModelBase implements PostTargetModel {
  constructor(dataContext?: PremisesPostTarget) {
    super();
    if (dataContext) {
      this.id = dataContext.id || '';
      this.companyNumberName = dataContext.companyNumberName || '';
      this.propertyNumberName = dataContext.propertyNumberName || '';
      this.buildingNumberName = dataContext.buildingNumberName || '';
      this.premisesNumberName = dataContext.premisesNumberName || '';
    }
  }

  companyNumberName: string;
  propertyNumberName: string;
  buildingNumberName: string;
  premisesNumberName: string;

  postTargetDescription() {
    return {
      key: 'POST.POST_TARGET_DESCRIPTION.PREMISES',
      params: {
        companyName: this.companyNumberName,
        propertyName: this.propertyNumberName,
        buildingName: this.buildingNumberName,
        premisesName: this.premisesNumberName,
      },
    };
  }

  toAutocompleteValue(viewType: 'list' | 'field', culture?: string): string {
    switch (viewType) {
      case 'field':
      case 'list':
        return this.premisesNumberName;
    }
  }

  toString(culture?: string): string {
    return this.premisesNumberName;
  }
}
